const it = {
    application_title: 'Login',
    japanese: 'Giapponese',
    english: 'Inglese',
    french: 'Francese',
    german: 'Tedesco',
    italian: 'Italiano',
    spanish: 'Spagnolo',
    language: 'Lingua',
    login_selectscreen: 'Seleziona lo schermo',
    login_all: 'tutti',
    login_executive: 'Esecutivo',
    login_manager: 'Manager',
    login_operator: 'Operatore',
    login_forgot_password: 'Hai dimenticato la tua password',
    user_id: 'Nome utente',
    user_password: 'password',
    authorizer: 'Autorizzatore',
    authorizer_text: 'Nota: Inserire l\'indirizzo e-mail dell\'autorizzatore. L\'autorizzatore deve essere un dipendente Konica Minolta (un utente con un dominio konica minolta).',
    sign_in: 'Accedi',
    sign_in_error: 'Nome utente o password errati',
    create_account: 'Crea un nuovo account',
    forget_password_title: 'Si prega di inviare una richiesta di reimpostazione della password all\'indirizzo e-mail qui sotto.',
    forget_password_email: 'dashboard-u_support2@gcp.konicaminolta.com',
    forget_password_text: 'Si prega di copiare il testo qui sotto, incollarlo nell\'oggetto e inviarlo via e-mail.\n\
    >[Request] Puoi lasciare in bianco il messaggio principale dell\'email.\n\
Si prega di inviare l\'e-mail dall\'indirizzo e-mail registrato in questo software.\n\
Potremmo non essere in grado di rispondere alle richieste provenienti da indirizzi e-mail non registrati.\n\
Se non si riceve una risposta entro 24 ore lavorative, si prega di inviare nuovamente il messaggio.\n\
Si prega di notare che il tuo account sarà cancellato se non riesci a confermare il tuo login entro un mese dalla ricezione di questa e-mail.\n\
Si prega di confermare la notifica della nuova password dal seguente indirizzo e-mail.\n\
"no-reply@verificationemail.com"',
    forget_password_team: 'AccurioPro Dashboard Op-Analysis Operation Team',
    privacy_statement: 'Dichiarazione sulla privacy',
    privacy_statement_contents: 'Konica Minolta Business Solutions Europe GmbH e le sue filiali, società consociate e società madri elencate nell\'allegato 1. ("Konica Minolta"), prendiamo sul serio la questione della privacy. Questa politica sulla privacy fornisce informazioni sui modi in cui raccogliamo, utilizziamo, divulghiamo e gestiamo in altro modo i dati personali. \n\n\
Chi è il controllore dei dati? \n\
Konica Minolta utilizzerà i vostri dati personali menzionati di seguito. \n\
ell\'ambito dei dati personali \n\
Quali informazioni raccogliamo su di te? \n\
Konica Minolta raccoglie il tuo indirizzo e-mail. \n\
ell\'ambito delle informazioni personali.\n\
Come verranno utilizzate le tue informazioni? \n\
Konica Minolta utilizza le informazioni di cui sopra solo per lo scopo seguente: \n\
Identificazione e; \n\
contatto per fornire le informazioni necessarie su AccurioPro Dashboard. \n\
ell\'identificazione e; \n\
ella fornitura delle informazioni necessarie su AccurioPro Dashboard.\n\
Qual è la nostra base giuridica per il trattamento dei tuoi dati personali? \n\
L\'interesse legittimo è la base giuridica del trattamento. \n\
Gli interessi legittimi sono a) identificazione e b) contatto per fornire le informazioni necessarie su AccurioPro Dashboard. \n\
ell\'interesse legittimo \n\
Chi riceve i tuoi dati? \n\
I vostri dati personali di cui sopra saranno trattati con la massima riservatezza e non saranno condivisi con terzi senza il vostro consenso. \・Il periodo di conservazione dei dati \n\
Periodo di conservazione \n\
Konica Minolta elaborerà i dati personali per tutta la durata della tua necessità di utilizzare AccurioPro Dashboard per il tuo incarico e continuerà a conservare solo i dati personali necessari per tre mesi dopo che il tuo incarico è cambiato o hai lasciato l\'azienda ("Cambiamento"). Durante il periodo di cancellazione dal Cambiamento a tre mesi dal Cambiamento, tutti i dati personali non necessari saranno cancellati perché Konica Minolta cancella i dati personali non necessari ogni trimestre. \n\n\
Memorizzazione dei dati e trasferimento dei dati \n\
I dati sono conservati in Germania. Per l\'identificazione e il contatto, Konica Minolta, Inc. è coinvolta.  Il Giappone è un paese che garantisce un adeguato livello di protezione dei dati personali deciso dalla Commissione Europea. \n\n\
Quali sono i tuoi diritti secondo il GDPR? \n\
Mentre Konica Minolta è in possesso o elabora i vostri dati personali, avete i seguenti diritti: \n\
Diritto di accesso - hai il diritto di richiedere una copia delle informazioni che abbiamo su di te. \n\
Diritto di rettifica - avete il diritto di correggere i dati inesatti o incompleti in nostro possesso che vi riguardano. \n\
Diritto all\'oblio - in determinate circostanze puoi chiedere che i dati che abbiamo su di te vengano cancellati dai nostri archivi. \n\
Diritto alla limitazione del trattamento - se si applicano determinate condizioni, si ha il diritto di limitare il trattamento. \n\
Diritto alla portabilità - ha il diritto di far trasferire i dati in nostro possesso ad un\'altra organizzazione. \n\
Diritto di opposizione - ha il diritto di opporsi a certi tipi di trattamento come il marketing diretto. \n\
Diritto di opporsi al trattamento automatizzato, compresa la profilazione - ha anche il diritto di essere soggetto agli effetti legali del trattamento automatizzato o della profilazione. \n\
Nel caso in cui Konica Minolta rifiuti la vostra richiesta in base ai diritti di accesso, vi forniremo una spiegazione ragionevole. \n\
Se esercitate uno dei vostri diritti, vi preghiamo di inviare un\'e-mail a dashboard-u_support1@gcp.konicaminolta.com. \n\n\
Dati di contatto del titolare del trattamento \n\
Siete invitati a contattare la nostra azienda in qualsiasi momento se avete domande relative al tema della privacy dei dati. I dati di contatto delle altre società sono menzionati nell\'allegato 2. \n\
Konica Minolta Business Solutions Europe GmbH \n\
Europaallee 17 \n\n\
30855 Langenhagen \n\
Germania Telefono: +49 (0)511 7404-0 \n\
E-Mail: dataprotection(at)konicaminolta.eu \n\
Allegato.1 \n\
Konica Minolta Business Solutions Deutschland GmbH, \n\
Konica Minolta Business Solutions France S.A.S., \n\
Konica Minolta Business Solutions (UK) Limited, \n\
Konica Minolta Business Solutions Romania s.r.l., \n\
Konica Minolta Business Solutions Italia S.p.A., \n\
Konica Minolta Business Solutions Nederland B.V., \n\
Konica Minolta Business Solutions Greece S.A., \n\
Konica Minolta Business Solutions Czech spol. s r.o., \n\
Konica Minolta Hungary Business Solutions Ltd., \n\
Konica Minolta Business Solutions Polska Sp.z.o.o., \n\
Konica Minolta Business Solutions Bulgaria EOOD, \n\
Konica Minolta Business Solutions Slovenia d.o.o., \n\
Konica Minolta Croatia-Business Solutions d.o.o., \n\
Konica Minolta Slovakia spol. s.r.o., \n\
Konica Minolta Baltia UAB, \n\
Konica Minolta Business Solutions Denmark A/S, \n\
Konica Minolta Business Solutions Spain S.A., \n\
Konica Minolta Business Solutions Sweden AB, \n\
Konica Minolta Business Solutions Norway AS, \n\
Konica Minolta Business Solutions (Belgium) N.V., \n\
Konica Minolta Business Solutions Austria GmbH, \n\
Konica Minolta Business Solutions Portugal, Unipessoal Lda. \n\
Konica Minolta Business Solutions Finland Oy, e \n\
Konica Minolta, Inc. con sede in 2-7-2, Marunouchi, Chiyoda-ku, Tokyo, Giappone. \n\
Allegato.2 \n\
Konica Minolta Business Solutions Deutschland GmbH \n\
Europaallee 17, 30855 Langenhagen, Germania \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions France S.A.S. \n\
365-367 Route de Saint-Germain, F-78424 Carrieres-sur-Seine, Francia \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions (UK) Limited \n\
Miles Gray Road,Basildon,Essex,SS14 3AR. \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Romania s.r.l. \n\
Str. Copilului nr. 18, parter, sector 1, 012178 Bucarest, Romania \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Italia S.p.A. \n\
Viale Certosa, 144, 20156 Milano, Italia \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Nederland B.V. \n\
Hoogoorddreef 9, Postbus 22110, 1100 CC Amsterdam, Paesi Bassi \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Greece S.A. \n\
3, Messologiou Str., GR-14451 Metamorphosis, Atene, Grecia \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Czech spol. s r.o. \n\
Brno - Židenice, Žarošická 4395/13, PSČ 628 00, Repubblica Ceca \n\
dashboard-u_support1@gcp.konicaminolta.com \n\n\
Konica Minolta Hungary Business Solutions Ltd. \n\
Galvani u. 4., 1117 Budapest, Ungheria \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Polska Sp.z.o.o. \n\
Muszkieterów 15, 02-273 Warszawa, Polonia \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Bulgaria EOOD \n\
Biznes park Sofia 7, 1715 Sofia, Bulgaria \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Slovenia d.o.o. \n\
Vodovodna cesta 101, 1000 Ljubljana, Slovenia \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Croatia-Business Solutions d.o.o. \n\
Radnicka cesta 1a, HR-10000 Zagabria, Croazia \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Slovakia spol. s.r.o. \n\
Cernysevskeho 10, 85101 Bratislava, Repubblica Slovacca \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Baltia UAB \n\
J. Jasinskio str. 16, LT2001 Vilnius, Lituania \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Denmark A/S \n\
Lautrupvang 2B, 2750 Ballerup, Danimarca \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Spain S.A. \n\
C/ Albasanz, 12, 28037 Madrid, Spagna \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Sweden AB \n\
Kronborgsgränd 19, S-164 46 Kista, Svezia o P.O. Box 1125, S-164 22 Kista, Svezia \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Norway AS \n\
Maridalsveien 323, 0872 Oslo, Norvegia \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions (Belgium) N.V. \n\
Excelsiorlaan 10, 1930 Zaventem, Belgio \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Austria GmbH \n\
Amalienstrasse 59-61, A-1131 Vienna, Austria \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Portugal, Unipessoal Lda. \n\
Rua Professor Henrique de Barros nº 4, 10º B 2685-338 Prior Velho, Portogallo \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Finland Oy \n\
Keilaranta 10 E, 02150 Espoo, Finlandia \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta, Inc. \n\
2-7-2 Marunouchi, Chiyoda-ku, Tokyo, \n\
Giappone \n\
dashboard-u_support1@gcp.konicaminolta.com',
    register: 'Registra',
    update: 'Update',
    email: 'indirizzo e-mail',
    fields_compulsory: 'Tutti i campi sono obbligatori',
    authorizer_email_error: 'Indirizzo e-mail dell\'autore non valido.',
    email_error: 'Indirizzo e-mail non valido.',
    username_error: 'Per il nome dell\'utente si possono inserire solo caratteri alfanumerici.',
    serial_number_duplicate_error: 'I numeri di serie sono duplicati.',
    password_match_error: 'Le password non corrispondono',
    not_km_domain: 'Il dominio dell\'indirizzo e-mail dell\'autorizzatore non è il dominio di konicaminolta',
    registered: 'Registrato!',
    add_account_email_text: 'Caro {authorizer},%0D%0A%0D%0A{email} hanno creato il proprio account di Printer Performance Analysis tool.%0D%0A%0D%0A\n\n\
Chiunque non sia membro di Konica Minolta può utilizzare questa applicazione con l\'approvazione di un utente Konica Minolta.%0D%0A\n\
Quindi, per favore, accedi all\'URL qui sotto e approvalo.%0D%0A%0D%0A\n\
URL %0D%0A\n\
{url} %0D%0A%0D%0A\n\n\
Cordiali saluti,%0D%0A\n\
Konica Minolta Inc.%0D%0A\n\n\
',
    customer_email_text: 'Caro {email},%0D%0A%0D%0A\
Abbiamo creato il tuo account per Printer Performance Analysis tool.%0D%0APer favore accedi all\'URL sottostante.%0D%0A\
URL: https://dashboard-u.konicaminolta.com%0D%0A\
nome utente: {userId}%0D%0A\
password: {password}%0D%0A%0D%0A\
Puoi usare tutte le funzioni di questa applicazione dopo aver inserito il PKID nella funzione di impostazione della licenza.%0D%0A\
*Il PKID ti sarà inviato via e-mail separatamente. Si prega di essere sicuri che.%0D%0A%0D%0A\
Cordiali saluti,%0D%0AKonica Minolta Inc.',
    request_to_you: 'Richiesta a voi',
    http_get_error: '{status}: Elaborazione fallita. Torna alla schermata di login.',
    server_error: 'Errore interno del server.',
    http_connection_error: 'Non collegato a internet.',
    ce_top_title: 'Seleziona il cliente a cui vuoi accedere.',
    add_customers_account: 'Aggiungere l\'account del cliente',
    go_back: 'Indietro',
    customers: 'I vostri clienti',
    serial_numbers: 'Numeri di serie registrati',
    open: 'Aprire',
    add_sn: 'Aggiungere il numero di serie della stampante',
    add_ce: 'Aggiungi CE per seguire questo cliente',
    printers_sn: 'Numero di serie della stampante',
    edit_customer_title: 'Modifica della registrazione del cliente',
    customer_email_address: 'Indirizzo e-mail del cliente',
    license: 'Licenza',
    printers_registered: 'Stampanti registrate',
    serial_number: 'Numero di serie',
    latest_data: 'Ultimi dati',
    persons_in_charge: 'Persone responsabili',
    customer_engineer: 'Ingegnere del cliente',
    sender: 'da',
    authorization: 'Autorizzazione',
    approve: 'approvare',
    do_not_approve: 'Non approvare',
    request_approved: 'Richiesta approvata!',
    request_disapproved: 'Richiesta non approvata!',
    approved: 'Approvato',
    do_not_approved: 'Rifiutato',
    processed_result: 'Risultato elaborato',
    processed_date: 'Data di elaborazione',
    header_nfr: 'Licenza non per rivendita (NFR)',
    header_recommendation: 'Raccomandazione',
    header_previous: 'precedente',
    header_next: 'prossimo',
    header_reset: 'resettare',
    header_change_password: 'Cambiare la password',
    header_settingMenu_tutorial: 'Tutorial',
    header_old_password: 'Password attuale',
    header_new_password: 'Nuova password',
    header_confirm_password: 'Nuova password (Conferma)',
    header_cancel: 'Annulla',
    header_apply: 'applicare',
    header_ok: 'OK',
    header_close: 'chiudere',
    from: 'da',
    to: 'a',
    change_date_heading: 'Impostazione della portata',
    change_date_explanation: 'Seleziona il periodo di tempo per l\'esportazione CSV',
    header_password_explanation: 'Si prega di creare una password con una stringa di 8 o più caratteri che includa lettere maiuscole e minuscole e numeri.',
    header_machine_setting: 'Impostazione della macchina',
    header_machine_setting_title: 'Impostazione della macchina',
    header_machine_setting_notes: 'Impostazione della macchina',
    header_machine_setting_model: 'Modello',
    header_machine_setting_serial_number: 'S/N：',
    header_machine_setting_machine_name: 'Nome della macchina',
    header_machine_setting_error_message_max_length: 'Si prega di inserire 64 caratteri o meno.',
    header_machine_setting_error_message_min_length: 'Inserire il nome della macchina.',
    header_machine_setting_error_message_common: 'Si prega di controllare il contenuto del nome della macchina.',
    header_machine_setting_complete_message: 'L\'aggiornamento è completato. Ricaricare il display.',
    header_lms_setting: 'Impostazione della licenza',
    header_lms_explanation: 'Immettere il codice prodotto notificato via e-mail, premere il pulsante "referenza" e quindi premere il pulsante "attiva".',
    header_lms_add: 'Aggiungi',
    header_lms_delete: 'Cancellare',
    header_lms_pkIdTitle: 'Product Key',
    header_lms_refer: 'fare riferimento a',
    header_lms_licenseKind: 'tipo di licenza',
    header_lms_licenseDate: 'licenza scaduta',
    header_lms_licenseState: 'attivare lo stato',
    header_lms_activate: 'attivare',
    header_lms_deactivate: 'disattivare',
    header_lms_state_activate: 'attivare',
    header_lms_state_deactivate: 'disattivare',
    header_lms_ptl_date: 'La licenza di prova scadrà il',
    header_lms_activationDate: 'Attivazione disponibile',
    header_lms_never_expired: 'Mai scaduto',
    header_users_guide: 'Guida all\'uso',
    header_users_guide_link: 'https://www.btapac.konicaminolta.com/users_guide/accuriopress_C14000_series/3_0_0/en/index.html',
    header_version_info: 'Versione',
    screen1_productivity_rate: 'Tasso di produttività',
    screen1_productivity_pred: 'Previsione della produttività',
    screen1_week_before_last_availability: 'La settimana prima dell\'ultima',
    screen1_productivity_diff: 'Differenza effettiva',
    screen1_week_before_last_pred_diff: 'Differenza tra la previsione della settimana precedente e quella effettiva',
    screen1_productivity_a4_tips: 'La produttività è convertita in formato A4',
    screen1_productivity_a3_tips: 'La produttività è convertita in formato A3',
    screen1_results_of_production: 'Risultati della produzione',
    screen1_est_print_time: 'Tempo di stampa previsto (hh:mm)',
    screen1_act_print_time: 'Tempo effettivo di stampa (hh:mm)',
    screen1_gap: 'Spazio (hh:mm)',
    screen1_sheets: 'numero di stampe',
    screen1_sheets_per_h: 'numero di stampe/ora',
    screen1_availability: 'Tasso di realizzazione (%)',
    screen1_job_list_link: 'Elenco degli ordini',
    screen1_machine_list_link: 'Elenco delle macchine',
    top_manager_title_production_result: 'Totale',
    top_manager_title_prints: 'Stampe',
    top_manager_title_errors: 'errori',
    top_manager_jobs: 'lavori di stampa',
    top_manager_color_pv: 'pagine a colori',
    top_manager_bw_pv: 'Pagine in bianco e nero',
    top_manager_output_paper: 'Pagine stampate',
    top_manager_trayfull_count: 'vassoio di uscita pieno',
    top_manager_paperjams__count: 'Inceppamento della carta',
    top_manager_servicecall_count: 'chiamata di servizio',
    top_manager_paperempty_count: 'Vassoio della carta vuoto',
    top_manager_tonerempty_count: 'Toner vuoto',
    top_operator_title_production_result: 'Risultati del funzionamento dell\'unità',
    top_operator_title_trouble_result: 'Totale',
    top_operator_subtitle_output_paper_result: 'Tendenza sul numero di pagine prodotte',
    top_operator_subtitle_output_availability_result: 'risultati dell\'operazione',
    top_operator_paper_count: 'Conteggio della carta in uscita',
    top_operator_subtitle_output_paper_count: 'Conteggio della carta in uscita',
    top_operator_subtitle_interruption_result: 'Risultati dell\'interruzione (min)',
    top_operator_trayfull: 'vassoio di uscita pieno',
    top_operator_paperempty: 'Vassoio della carta vuoto',
    top_operator_tonerempty: 'Toner vuoto',
    top_operator_paperjams: 'Inceppamento della carta',
    top_operator_servicecall: 'chiamata di servizio',
    top_operator_explanation_worst1: 'Peggior fattore di arresto ',
    top_operator_explanation_worst2: '2º ',
    top_operator_explanation_worst3: '3º ',
    screen3_print_hours: 'ore',
    listofprintjobs_title: 'Elenco degli ordini',
    listofprintjobs_number: 'No.',
    listofprintjobs_start_time: 'Ora di inizio',
    listofprintjobs_job_id: 'numero d\'ordine',
    listofprintjobs_pages_set: 'pagine/<br>imposta',
    listofprintjobs_output_set: 'imposta<br>di uscita',
    listofprintjobs_exit_count: 'Conteggio della carta in uscita',
    listofprintjobs_machine_name: 'sistema di stampa',
    jobdetail_left_title: 'dettagli del lavoro',
    jobdetail_timeline_title: 'Timeline di uscita',
    jobdetail_job_id: 'numero d\'ordine ',
    jobdetail_size: 'formato carta ',
    jobdetail_paper_kind: 'tipo di carta',
    jobdetail_paper_weight: 'Peso carta/Spessore',
    jobdetail_color: 'Mono/Colore',
    jobdetail_side: 'lato singolo / lato doppio',
    jobdetail_pages: 'pagine/imposta',
    jobdetail_unit_pages: 'Pagine',
    jobdetail_units: 'imposta di uscita',
    jobdetail_unit_units: 'numero di imposta',
    jobdetail_sheets: 'Conteggio della carta in uscita',
    jobdetail_unit_sheets: 'fogli',
    jobdetail_center_title: 'sistema di stampa',
    jobdetail_machine_name: 'Nome della macchina',
    jobdetail_tray_full: 'vassoio di uscita pieno',
    jobdetail_paper_empty: 'Vassoio della carta vuoto',
    jobdetail_toner_empty: 'Toner vuoto',
    jobdetail_paper_jam: 'Inceppamento della carta',
    jobdetail_service_call: 'chiamata di servizio',
    jobdetail_panel_operation: 'Pannello operativo',
    jobdetail_frontdoor_open: 'Porta del sistema',
    jobdetail_tray_open: 'Vassoio della carta',
    jobdetail_right_title: 'Differenza tra il tempo di stampa previsto e quello effettivo',
    jobdetail_graph_x_title: 'Tempo di stampa previsto (hh:mm)',
    jobdetail_graph_y_title: 'Tempo effettivo di stampa',
    jobdetail_legend_jobs: 'Uscita del lavoro in {machineName}',
    jobdetail_legend_target: 'Questo lavoro di stampa',
    jobdetail_tooltip_jobid: 'numero d\'ordine:',
    jobdetail_tooltip_diff: 'Differenza: ',
    jobdetail_tooltip_actual: 'Tempo di stampa effettivo: ',
    jobdetail_tooltip_assumed: 'Tempo di stampa presunto:',
    jobdetail_start_time: 'ora di inizio',
    jobdetail_end_time: 'tempo di fine',
    availabilitydetail_left_title: 'Elenco delle macchine',
    availabilitydetail_center_title: 'Differenza tra le macchine',
    availabilitydetail_right_title: 'Tendenza del tempo di stampa per macchina',
    availabilibydetail_unit_hour: 'ore',
    availabilibydetail_machine: 'Macchina',
    availabilibydetail_unit_idle: 'Inattivo',
    availabilibydetail_unit_interruption: 'Interruzione della stampa',
    availabilibydetail_unit_preparation: 'Preparazione alla stampa',
    availabilibydetail_unit_printing: 'sta stampando',
    joblist_title: 'Elenco degli ordini',
    joblist_number: 'No.',
    joblist_estprinttime: 'Tempo di stampa previsto (hh:mm)',
    joblist_actprinttime: 'tempo reale di stampa (hh:mm)',
    joblist_hourlyunits: 'Uscita oraria a pagine',
    joblist_printcompletedtime: 'Tempo di stampa (hh:mm)',
    joblist_printtimediff: 'Gap (hh:mm)',
    joblist_csv_export: 'Esportazione CSV',
    joblist_est_hourlyunits: 'Pagine previste per ora',
    joblist_est_printcompletedtime: 'Tempo di stampa previsto (hh:mm)',
    joblist_act_hourlyunits: 'Pagine effettive per ora',
    joblist_act_printcompletedtime: 'Tempo effettivo di stampa',
    proddetail_title: 'Gap di previsione del tempo di stampa',
    proddetail_table_title: 'Tendenze del volume di produzione',
    proddetail_graph_yaxis_left: 'Tempo di stampa (hh:mm)',
    proddetail_graph_yaxis_right: 'Tasso di realizzazione (%)',
    proddetail_est_print_time: 'Tempo di stampa previsto',
    proddetail_act_print_time: 'Tempo effettivo di stampa',
    proddetail_gap: 'Spazio (hh:mm)',
    proddetail_duration_daily: 'quotidiano',
    proddetail_duration_weekly: 'settimanale',
    proddetail_duration_monthly: 'mensile',
    machinedetail_left_title: 'Dettagli della macchina',
    machinedetail_center_title: 'errori',
    machinedetail_right_title: 'Dettagli della macchina disponibile',
    machinedetail_availability: 'disponibilità',
    machinedetail_operating_time: 'Tempo operativo (ore)',
    machinedetail_printing_time: 'Tempo di stampa (ore)',
    machinedetail_output_set: 'imposta di uscita',
    machinedetail_output_paper: 'Conteggio della carta in uscita',
    machinedetail_power_on: 'Accensione',
    machinedetail_power_off: 'Spegnimento',
    common_min_per_week: 'min/settimana',
    common_2days_ago: 'l\'altro ieri',
    common_yesterday: 'ieri',
    common_today: 'Oggi',
    common_tomorrow: 'domani',
    common_2days_after: 'dopodomani',
    common_2weeks_ago: '2 settimane fa',
    common_last_week: 'La settimana scorsa',
    common_this_week: 'questa settimana',
    common_next_week: 'la prossima settimana',
    common_2weeks_after: 'la settimana dopo la prossima',
    common_2months_ago: '2 mesi fa',
    common_last_month: 'mese scorso',
    common_this_month: 'questo mese',
    common_next_month: 'il mese prossimo',
    common_2months_after: 'mese dopo il prossimo mese',
    common_days_ago: '{dateNum} giorni fa',
    common_weeks_ago: '{dateNum} mesi fa',
    common_months_ago: '{dateNum} mesi fa',
    common_days_after: '{dateNum} giorni dopo',
    common_weeks_after: '{dateNum} settimane dopo',
    common_months_after: '{dateNum} mesi dopo',
    common_mins: 'minuti',
    common_hours: 'ore',
    common_date: 'Data',
    common_percentage: '%',
    icon_recommendation: 'Raccomandazione',
    icon_analysis: 'Analisi',
    icon_operation: 'Operazione',
    icon_machine: 'Macchina',
    icon_material: 'Materiale',
    icon_method: 'Metodo',
    icon_running_time: 'tempo di esecuzione',
    icon_preparation_time: 'Preparazione alla stampa',
    icon_downtime: 'Interruzione della stampa',
    paperEmpty: 'carta vuota',
    tonerEmpty: 'toner vuoto',
    trayFull: 'Cassetto carta pieno',
    Total: 'Totale',
    Average: 'AVE.',
    hour_unit: 'ore',
    date_format: 'DD.MM.YY',
    date_format2: 'DD.MM',
    month_format: 'MM.YY',
    errCode_10000: 'Cambio di password fallito.',
    errCode_10001: 'La nuova password e la nuova password (conferma) non corrispondono.',
    errCode_10002: 'La password deve essere una stringa di almeno 8 caratteri che includa lettere maiuscole e minuscole e numeri',
    errCode_10003: 'Aspetta circa 10 minuti e poi cambia di nuovo la tua password',
    errCode_10004: 'La password attuale non è corretta.',
    errCode_10005: 'La tua sessione è scaduta. Si prega di effettuare nuovamente il login.',
    errCode_10006: 'Si è verificato un errore di rete.',
    errCode_10100: 'Si è verificato un errore. Si prega di contattare l\'amministratore.',
    errCode_10101: 'Inserire il codice prodotto.',
    errCode_10102: 'Impossibile ottenere le informazioni sul codice prodotto.',
    errCode_10103: 'Attivazione fallita.',
    errCode_10104: 'Disattivazione fallita.',
    errCode_10105: 'Non è stato possibile eliminare le informazioni sul codice prodotto.',
    errCode_10106: 'Non è possibile impostare lo stesso codice prodotto.',
    errCode_10007: 'Controllare l\'e-mail di verifica ed effettuare il login dal link contenuto nel corpo dell\'e-mail.',
    errCode_20000: 'Parametro non valido.',
    errCode_20001: 'L\'indirizzo e-mail specificato esiste già.',
    errCode_20002: 'Il nome utente specificato esiste già, specificare un altro nome utente.',
    errCode_20003: 'Il nome utente specificato non è registrato come cliente.',
    suggestion_overview: 'Panoramica',
    suggestion_pgap_overview_good: 'Gap di Previsione è diminuito',
    suggestion_pgap_overview_bad: 'il divario di Predizione è aumentato',
    suggestion_pgap_overview_even: 'Gap di previsione non è cambiato',
    suggestion_ma_overview_good: 'Il tasso di disponibilità è aumentato',
    suggestion_ma_overview_bad: 'Il tasso di disponibilità è diminuito',
    suggestion_ma_overview_even: 'Il tasso di disponibilità non è cambiato',
    suggestion_attention_machine: 'la macchina richiede attenzione: ',
    suggestion_tips: 'Suggerimenti',
    suggestion_pv_up: 'Il volume di stampa è aumentato',
    suggestion_pv_down: 'Il volume di stampa è diminuito',
    suggestion_pv_even: 'Il volume di stampa non è cambiato',
    suggestion_downtime_long: 'I tempi di inattività sono aumentati',
    suggestion_smalljob_many: 'I lavori per i piccoli lotti sono aumentati',
    suggestion_efficiency_up: 'L\'efficienza della produzione è aumentata',
    ce_login_tutorial: 'Per la distribuzione, consultare il tutorial',
    ce_dialog_header_confirm: 'Conferma',
    ce_confirmation_message: 'Vuoi davvero aggiornare i dettagli del cliente?',
    ce_email_confirmation: 'Verrà creata l\'email di inizializzazione della password del cliente. Sei sicuro?',
    username_email: 'Nome utente (indirizzo e-mail)',
    ce_dialog_header_info: 'Informazioni',
    ce_account_complete_kmce: 'La registrazione dell\'account è stata completata. Vai alla schermata di accesso.',
    ce_account_complete_dealer: 'La richiesta di registrazione dell\'account è stata completata. Si prega di attendere l\'approvazione.',
    ce_user_account_complete_kmce: 'La registrazione dell\'account è stata completata.',
    ce_user_account_complete_dealer: 'La richiesta di registrazione dell\'account è stata completata. Si prega di attendere l\'approvazione.',
    ce_error_400: 'Si è verificato un errore. Si prega di controllare il contenuto.',
    ce_error_409: 'Riacquisire le informazioni perché sono state aggiornate da un altro utente',
    ce_top_operator_user_name: 'La schermata dell\'operatore superiore di {userName}',
    add_new_customer: 'Aggiungi un nuovo cliente',
    add_existed_customer: 'Aggiungi un cliente esistente',
    ce_edit_licenseExpiresOn: 'Scade il',
    send_mail: 'Posta inviata con successo.',
    password_change_complete: 'Cambio di password completato.',
    reset_password: 'Ripristino della password',
    change_button: 'cambiare',
    send_button: 'inviare',
    common_error_500: 'Impossibile elaborare.',
    error_send_mail: 'Fallito l\'invio della posta.',
    error_confirm_password_incorrect: 'La password e la password di conferma sono diverse.',
    error_usename_not_exist: 'Il nome utente specificato non esiste.',
    error_id_not_exist: 'L\'id specificato non esiste.',
    error_id_mailaddress_not_exist: 'L\'id o l\'indirizzo e-mail specificato non esiste.',
    ce_forget_password_dialog_message: 'Inviare un\'e-mail di cambio password: si prega di cambiare la password dall\'URL descritto nel corpo dell\'e-mail.',
    user_forget_password_dialog_message: 'Si prega di riconfermare se si desidera cambiarlo, in quanto questo influenzerà tutti i membri che utilizzano questo account. L\'e-mail con la nuova password ti sarà inviata. Per favore, accedi con la password fornita nell\'e-mail. Se non conosci il tuo indirizzo e-mail, contatta il CE responsabile.',
    Mon: 'Lun',
    Tue: 'Mar',
    Wed: 'Mer',
    Thu: 'Gio',
    Fri: 'Ven',
    Sat: 'Sab',
    Sun: 'Dom',
    header_pending_verification: 'In attesa di verifica',
    pending_verification_dialog_message: 'L\'account è bloccato perché non viene utilizzato per molto tempo. È necessario inviare un\'e-mail di conferma?',
    trial_license_expired_message: 'La licenza di prova è scaduta. Inserire il codice prodotto',
    errCode_20004: 'URL non valido',
    error_code: 'Codice di malfunzionamento',
    jam_location: 'Posizione della congestione',
    device_time: 'tempo',
    machine_name: 'Macchina',
    paperJamsList_title: 'Elenco degli inceppamenti carta',
    error_support: 'Soluzione',
    error_describe: 'Dettaglio errore',
    serviceCallList_title: 'Elenco delle chiamate di servizio',
    tray: 'Vassoio di ingresso',
    paperEmptyList_title: 'Elenco dei rapporti di lavoro vacanti su carta',
    output_tray_name: 'Vassoio di uscita',
    trayFullList_title: 'Elenco dei messaggi completi del vassoio',
    tonerEmptyList_title: 'Elenco dei messaggi di esaurimento del toner',
    toner_color: 'Colore del toner',
    errorCount_tip: 'L\'elenco è stato sospeso per motivi di analisi o restrizione numerica.',
    solve_time: 'tempo di risoluzione',
    change_language: 'Cambiare lingua',
    machine_tab: 'Base',
    custom_group_tab: 'personalizzato',
    group_name: 'nome del gruppo',
    group_checkbox_tip: 'Il gruppo selezionato sarà selezionabile nell\'interfaccia utente.',
    group_edit_tip: 'È possibile aggiungere un set personalizzato di visualizzazione della macchina.',
    custom_group: 'Nome del gruppo definito dall\'utente',
    group_comment: 'Commento',
    machine_checkbox_tip: 'Quando si seleziona il gruppo, viene visualizzata la macchina selezionata.',
    group_name_exits: 'Il nome del gruppo specificato esiste già.',
    header_group_name_max_length: 'Inserire 64 caratteri o meno.',
    header_group_name_min_length: 'Inserire il nome del gruppo.',
    header_group_comment_max_length: 'Inserire 128 caratteri o meno.',
    header_device_group_switch: 'Gruppo di dispositivi:',
    header_group_all: 'Tutti(fogli)',
    header_group_color: 'Colore',
    header_group_monochrome: 'bianco e nero ',
    header_group_detail_length: 'Nel gruppo personalizzato deve essere selezionata almeno una macchina.',
    header_group_select_tip: 'Non c\'è nessuna macchina nel gruppo selezionato. Registrare la macchina nel gruppo.',
    group_name_specialchar_tip: 'Il carattere speciale @ non può essere inserito',
    change_date_heading_week: 'Selettore della settimana',
    machine_time_line: 'linea del tempo',
    header_group_ppall: 'AccurioPress/Print',
    header_group_km1: 'AccurioJet',
    top_manager_otherTransporterror_count: 'Altro errore di trasporto',
    otherTransportErrorList_title: 'Elenco di altri errori di trasporto',
    jobdetail_otherTransporterror: 'Altro errore di trasporto',
    top_operator_otherTransporterror: 'Altro errore di trasporto',
    errCode_10008: 'La chiave è sbagliata o scaduta.',
    feeder: 'Alimentazione',
    license_expired_message: 'La licenza è scaduta',
    logout_dialog_msg: 'Tutte le funzioni non possono essere utilizzate finché la licenza non è valida. ',
    header_logout_yes: 'uscire dal sistema',
    header_logout_no: 'Annulla',
    paper_weight: 'peso carta',
    paper_thickness: 'Spessore',
    errCode_10009: 'Il SN non è registrato.',
    errCode_10010: 'Accesso richiesto',
    errCode_10011: 'Nessun dispositivo registrato',
    ce_reset_password_dialog_title: 'Notifica di informazioni sul conto del cliente',
    ce_reset_password_dialog_ultimate: 'Azzeramento Op-Analysis',
    ce_reset_password_dialog_job_manager: 'Azzeramento JobManager',
    ce_reset_password_dialog_all: 'Azzeramento di entrambi',
    customer_email_text_job_manager: 'Gentile {email},%0D%0A%0D%0A\
Abbiamo creato il tuo account per AccurioPro Dashboard JobManager.%0D%0APer favore accedi all\'URL qui sotto.%0D%0A\
URL: https://dashboard-jm.konicaminolta.com%0D%0A\
nome utente: {userId}%0D%0A\
ID operatore: amministratore%0D%0A\
password: {password}%0D%0A%0D%0A\
È possibile utilizzare tutte le funzioni di questa applicazione dopo aver inserito il codice prodotto nella funzione di impostazione della licenza.%0D%0A\
*Il codice prodotto verrà inviato separatamente via e-mail. Si prega di accertarsi di ciò.%0D%0A%0D%0A\
Cordiali saluti,%0D%0AKonica Minolta Inc.',
    customer_email_text_all: 'Gentile {email},%0D%0A%0D%0A\
Abbiamo creato il suo account per Printer Performance Analysis tool e AccurioPro Dashboard JobManager.%0D%0Acceda all\'URL sottostante.%0D%0A\
URL: https://dashboard-u.konicaminolta.com%0D%0A\
nome utente: {ultimateUserId}%0D%0A\
ID operatore: amministratore%0D%0A\
Password finale: {ultimatePassword}%0D%0A\
Password del JobManager: {jobManagerPassword}%0D%0A%0D%0A\
È possibile utilizzare tutte le funzioni di questa applicazione dopo aver inserito il codice prodotto nella funzione di impostazione della licenza.%0D%0A\
*Il codice prodotto verrà inviato separatamente via e-mail. Si prega di accertarsi di ciò.%0D%0A%0D%0A\
Cordiali saluti,%0D%0AKonica Minolta Inc.',
    TZ_0000: 'Europe/West/GB, PT (+0)',
    TZ_0100: 'Europe/Central/FR, DE (+1)',
    TZ_0200: 'Europe/East/UA, GR (+2)',
    TZ_0300: 'Europe/East/TR, Moscow (+3)',
    TZ_0630: 'Asia/India (+5.5)',
    TZ_0700: 'Asia/Viet Nam (+7)',
    TZ_0800: 'Asia/China (+8)',
    TZ_0900: 'Asia/Japan, Korea (+9)',
    TZ_1400: 'Pacific/Hawaii (-10)',
    TZ_1500: 'America/Alaska (-9)',
    TZ_1600: 'America/West/Los Angeles (-8)',
    TZ_1700: 'America/Mountain/Denver (-7)',
    TZ_1800: 'America/Central/Chicago (-6)',
    TZ_1900: 'America/East/New York (-5)',
    TZ_2100: 'South America/Sao Paulo (-3)',
    time_zone_title: 'fuso orario',
    local_time: 'Ora locale',
    header_user_id: 'Nome utente',
    ce_customers_list_title: 'Elenco clienti',
    ultimate_license_expires_on: 'Op-Analysis (data di scadenza)',
    jm_license_expires_on: 'Job Manager (data di scadenza)',
    ce_customers_list_search: 'ricerca',
    ce_edit_registered: 'registrato',
    ce_edit_serialNumber: 'Numero di serie (macchina da stampa)',
    ce_edit_lastUpdatedDate: 'Data dell\'ultimo aggiornamento',
    ce_edit_responsibleCE: 'Ingegnere responsabile del cliente',
    ce_edit_customerInfo: 'Informazioni sul cliente',
    ce_edit_utimate: 'Op-Analysis',
    ce_edit_addSerialNumber: 'Aggiungere il numero di serie',
    ce_edit_jobManager: 'Job Manager',
    ce_edit_commonInfo: 'Informazioni comuni',
    ce_header_editCustomers: 'Modifica del cliente',
    ce_add_addCustomers_title: 'È possibile aggiungere un nuovo account cliente',
    ce_serial_number_list: 'Numero di serie',
    ce_essential_link_file: 'Essential Linked file',
    ce_location_on_off: 'Beta features on / off',
    date: 'Date',
    before_suggistion: 'Original suggestion text',
    after_suggestion: 'Suggestion to be updated',
    batch_edit: 'Bulk update',
    data_error: 'The data has been updated. Please refresh and save again.',
    edit_suggestion: 'Edit Suggestion',
    suggestion: 'Suggestion',
    user_suggestion_list: 'Suggestion list',
    delete_suggestion: 'Delete',
    top_operator_adjustment: 'Maintenance',
    color: 'Colore',
    monochrome: 'Mono',
    duplex: 'lato doppio',
    simplex: 'lato singolo',
    undefined_paper: 'Nessuno',
    normal_paper: 'Carta normale',
    colored_paper: 'Carta colorata',
    high_quality_paper: 'Carta di alta qualità',
    color_paper: 'Carta stampata a colori',
    coated_gloss_laser_paper: 'Carta laser patinata lucida',
    coated_mat_laser_paper: 'Carta laser patinata opaca',
    coated_gloss_offset_paper: 'Carta offset patinata lucida',
    coated_mat_offset_paper: 'Carta offset patinata opaca',
    embossing_paper: 'Carta goffrata',
    envelope: 'Busta',
    rough_paper: 'Carta ruvida',
    book_paper: 'Carta libro',
    coated_paper: 'Carta patinata',
    preprinted_paper: 'Carta prestampata',
    blank_insert_paper: 'Carta partizione vuota',
    generate_suggestion: 'Automated suggestion',
    error_Duration: 'Error Duration',
    jobdetail_processing_time: 'Processing Time',
    job_start_time: 'Ora di inizio',
    job_end_time: 'tempo di fine',
    add_customer_user_id: 'User name (for Customer login)',
    add_customer_email_address: 'Customer contact e-mail address',
    change_date_heading_day: 'Date selector',
    no_log: 'Dashboard Op-Analysis logs are not sent to CSRA/CSRC',
    unused_log: 'Dashboard Op-Analysis logs are not included in CSRA/CSRC logs',
    datetime_format: 'DD.MM.YY HH:mm:ss',
    header_jobs: 'Jobs',
    no_rows_label: 'Dati non disponibili',
    date_format3: 'DD.MM HH:mm',
    aqa_main_reason_fd_k: 'Vertical streak K',
    aqa_main_reason_fd_c: 'Vertical streak C',
    aqa_main_reason_fd_m: 'Vertical streak M',
    aqa_main_reason_fd_y: 'Vertical streak Y',
    aqa_main_reason_cd_k: 'Horizontal streak K',
    aqa_main_reason_cd_c: 'Horizontal streak C',
    aqa_main_reason_cd_m: 'Horizontal streak M',
    aqa_main_reason_cd_y: 'Horizontal streak Y',
    aqa_main_reason_dba_k: 'Uneven density K',
    aqa_main_reason_dba_c: 'Uneven density C',
    aqa_main_reason_dba_m: 'Uneven density M',
    aqa_main_reason_dba_y: 'Uneven density Y',
    aqa_main_reason_spot_k: 'Spot K',
    aqa_main_reason_spot_c: 'Spot C',
    aqa_main_reason_spot_m: 'Spot M',
    aqa_main_reason_spot_y: 'Spot Y',
    aqa_main_reason_backside_stain: 'Stain',
    machine_detail_timeline: 'Machine Detail Timeline',
    machine_detail_score_transition: 'Image total score transition',
    machine_detail_score_details: 'Diagnostic score details',
    machine_detail_diagnostic_history: 'DIAGNOSTIC HISTORY (Simple/Detailed)',
    machine_detail_dba_history: 'Maximum density transition',
    aqa_score_trend: 'Score',
    aqa_score_average_28days_trend: 'Trend (28 days average)',
    day_time: 'Date time',
    machine_id: 'MachineID',
    overall_score: 'Overall Score',
    main_factors: 'Main factors',
    machine_detail_score: 'Comprehensive image score',
    machine_detail_score_last_date: 'Latest date',
    machine_detail_score_last_num: 'Latest score',
    machine_detail_score_average_num: 'Historical average score',
    machine_detail_score_major_factor: 'Main factor',
    machine_detail_score_last: 'Latest score:',
    machine_detail_score_average_28days: '28 days average score:',
    aqa_diagnostic_score_legend_error: 'Error',
    aqa_diagnostic_score_legend_warning: 'Warning',
    aqa_diagnostic_score_legend_ok: 'OK',
    aqa_diagnostic_score_subtitle: 'Diagnostic Item',
    aqa_color: 'Color',
    aqa_fd_streak_rank: 'Vertical streak',
    aqa_cd_streak_rank: 'Horizontal streak',
    aqa_cd_banding_rank	: 'CD Banding',
    aqa_blurry_white_spot: 'White spot noise',
    aqa_blurry_color_spot: 'Color spot noise',
    aqa_white_spot: 'White speckle',
    aqa_black_spot: 'Black speckle',
    aqa_inky_backside: 'Stain',
    aqa_uneven_density: 'Uneven density',
    aqa_dba_adapt: '(Adjusted)',
    aqa_quality_information: 'Display AQA Quality Information',
    ce_sn_validation: 'Serial number should be 13 characters for KM printer',
    aqa_history_table_title: 'Image diagnosis (Simple/Detailed)',
    date_format4: 'DD.MM.YY HH:mm',
    header_group_AccurioLabel: 'AccurioLabel',
    header_group_registered_mixed_error: 'Web-fed machine can\'t be registered mixed with sheet-fed machine',
    label_machine_printed_length: 'Print length',
    label_machine_printed_length_with_unit: 'Print length(m)',
    label_machine_act_printed_length_with_unit: 'Act. Print length(m)',
    label_machine_printed_length_unit: 'm',
    label_machine_printed_length_time_unit: 'm/hour',
    label_machine_printed_length_with_unit2: 'Length/Set',
    label_machine_top_operator_subtitle_printed_length_result: 'Trend of print length',
    label_machine_top_operator_act_printed_length: 'Act. Print length',
    label_machine_screen_sheets_per_h: '#of prints(m/hour)',
    label_machine_joblist_est_hourlyunits: 'Pred. Print length(m/hour)',
    label_machine_joblist_act_hourlyunits: 'Act. Print length(m/hour)',
    header_machine_setting_remove_group_confirmation: 'Are you sure you want to remove this group "{group}"?',
    machinedetail_passed_day: '(Last 7 Days)',
    machinedetail_passed_week: '(Last 4 Weeks)',
    machinedetail_passed_month: '(Last 4 Months)',
    label_machine_waste_paper_length: 'Waste paper length',
    change_disabled_date_heading: 'Range',
    change_disabled_date_explanation: 'The duration of the CSV export',
    ce_edit_transportLog: 'Transport Log',
    ce_edit_transportLog_dialog_title: 'Transport Log Setting',
    ce_edit_transportLog_dialog_no: 'No.',
    ce_edit_transportLog_dialog_dev_env: 'Transport dev',
    ce_edit_transportLog_dialog_dev_stag: 'Transport sam',
    current_page: 'Current page:',
    total_pages: 'Total Pages:',
    ds_version_title: 'Version',
    ds_dashboard_version: 'KONICA MINOLTA AccurioPro Dashboard CE Version',
    ds_version_ds_num: '1.4.3',
    ds_version_oss: 'Disclosure of OSS information',
    ds_version_copyright: 'Copyright(C)2022',
    ds_version_companyName: 'KONICA MINOLTA.INC.',
    ds_import_cancle_btn: 'Close',
    header_settingMenu_version: 'Version',
    ce_application_sub_title: 'For Customer Engineers',
    ce_authorizer: 'Approver Email Address',
    ce_addCustomers_JMAndAQA_title: 'Both JobManager and Op-Analysis',
    ce_request_subTitle: 'Customer Info',
    ce_request_header_date: 'request date',
    ce_request_header_contents: 'contents',
    ce_header_link_request: 'request confirm',
    ce_edit_email_button: 'edit',
};
export default it;
